export const SET_CURRENT_USER = "SET_CURRENT_USER";

export const set_current_user_action = (data) => {
  return {
    type: SET_CURRENT_USER,
    payload: data,
  };
};
